import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { map } from 'rxjs/operators';
import { CostTypeService, ICostType, Page } from 'src/app/xena-api';

@Component({
    selector: 'app-file-select-importer',
    templateUrl: './file-select-importer.component.html',
    styleUrls: ['./file-select-importer.component.scss'],
    standalone: false
})
export class FileSelectImporterComponent {
  @Input() selecting: UntypedFormGroup;

  constructor(private costTypeService: CostTypeService) { }

  onFileSelected(event: any) {
    const selectedFile = event.target.files[0];
    this.selecting.get('file').setValue(selectedFile);
    this.selecting.get('file').markAsDirty();
  }

  getCostTypeListDatasource = (queryString: string): Promise<ICostType[]> =>
    this.costTypeService.list({ queryString, forceNoPaging: false })
      .pipe(map((x: Page<ICostType>) => x.entities))
      .toPromise();
}
